import { FC } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import CommonLayout from "containers/Client/AccountPage/CommonLayout";
import ModernPendingReservationsContainer from "components/Client/ModernPendingReservationsContainer";

export interface ModernListPendingOwnerPageProps {
  className?: string;
}

const ModernListPendingOwnerPage: FC<ModernListPendingOwnerPageProps> = ({ className = "" }) => {
  return (
    <CommonLayout>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        className={`nc-ModernListPendingOwnerPage relative min-h-screen ${className}`}
        data-nc-id="ModernListPendingOwnerPage"
      >
        <Helmet>
          <title>Demandes de Réservation | EventToBee - Gestion de vos espaces</title>
        </Helmet>

        {/* Background Pattern */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-orange-400/10 to-amber-600/10 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-tr from-orange-500/10 to-yellow-500/10 rounded-full blur-3xl"></div>
        </div>

        {/* Main Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <ModernPendingReservationsContainer className="pb-24 lg:pb-28" />
        </div>

        {/* Floating Elements */}
        <motion.div
          animate={{
            y: [0, -10, 0],
            rotate: [0, 1, 0],
          }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="absolute top-20 right-10 w-4 h-4 bg-gradient-to-br from-orange-400 to-amber-500 rounded-full opacity-60 blur-sm"
        />

        <motion.div
          animate={{
            y: [0, -15, 0],
            rotate: [0, -1, 0],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 2,
          }}
          className="absolute bottom-32 left-10 w-6 h-6 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full opacity-40 blur-sm"
        />
      </motion.div>
    </CommonLayout>
  );
};

export default ModernListPendingOwnerPage;
